/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';

/**
 * 
 * @export
 * @interface BulkUpdateShiftsResponse
 */
export interface BulkUpdateShiftsResponse {
    /**
     * 
     * @type {BatchSummary}
     * @memberof BulkUpdateShiftsResponse
     */
    data: BatchSummary;
}

/**
 * Check if a given object implements the BulkUpdateShiftsResponse interface.
 */
export function instanceOfBulkUpdateShiftsResponse(value: object): value is BulkUpdateShiftsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkUpdateShiftsResponseFromJSON(json: any): BulkUpdateShiftsResponse {
    return BulkUpdateShiftsResponseFromJSONTyped(json, false);
}

export function BulkUpdateShiftsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateShiftsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BatchSummaryFromJSON(json['data']),
    };
}

  export function BulkUpdateShiftsResponseToJSON(json: any): BulkUpdateShiftsResponse {
      return BulkUpdateShiftsResponseToJSONTyped(json, false);
  }

  export function BulkUpdateShiftsResponseToJSONTyped(value?: BulkUpdateShiftsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BatchSummaryToJSON(value['data']),
    };
}

